import { useState, useEffect, useRef } from "react";
import ProductHeader from "../../Components/ProductsPages/ProductHeader";
import ProductsHeroSection from "../../Components/ProductsPages/ProductsHeroSection";
import { Scroll } from "../../Components/ProductsPages/ScrollSection";
import { keyfeatures, servicestackdata } from "../../Data/ProductPages/Data";
import ProductFooter from "../../Components/ProductsPages/ProductFooter";
import { FeatureHover } from "../../Components/ProductsPages/FeatureHover";
import RequestDemo from "../../Components/ProductsPages/RequestDemo";
import QSleeveImage from "../../Images/videothumbnail.jpg";
import { Corousel } from "../../Components/ProductsPages/HorizontalCorousel";
import BackgroundGradient from "../../Images/BackgroundGradient.png";
import BackgroundGradientSmall from "../../Images/BackgroundGradientSmall.png";
import VideoComponent from "../../Components/VideoComponent";
import QSLEEVE from "../../../src/Images/Products/QSLEEVE_WN.png";
import QFORTE from "../../../src/Images/Products/QFORTE_WN.png";
import CHECQ from "../../../src/Images/Products/CHECQ_WN.png";
import QURNG from "../../../src/Images/Products/QuRNG_WN.png";
import QSLEEVE_P from "../../../src/Images/Products/QSLEEVE.png";
import CHECQ_P from "../../../src/Images/Products/CHECQ.png";
import QURNG_P from "../../../src/Images/Products/QuRNG.png";
import QSLEEVE_P1 from "../../../src/Images/Boxes/QSLEEVE_P1.png";
import QuRNG_P1 from "../../../src/Images/Boxes/QuRNG_P1.png";
import ChecQ_P1 from "../../../src/Images/Boxes/ChecQ_P1.png";
import ChecQ_P2 from "../../../src/Images/Boxes/ChecQ_P2.png";
import { ProductTable } from "../../Components/ProductsPages/ProductTable";
import { KeyFeatures } from "../../Components/KeyFeatures";
import { currentSite } from "../../Config/siteConfig";

const TabsSection = () => {
  const [activeTab, setActiveTab] = useState("QSleeve");

  const tabComponents = {
    QSleeve: <QSleeve />,
    ChecQ: <ChecQ />,
    QuRNG: <QuRNG />,
  };

  const tabs = [
    { id: "ChecQ", label: "ChecQ", image: CHECQ_P },
    { id: "QSleeve", label: "QSleeve", image: QSLEEVE_P },
    { id: "QuRNG", label: "QuRNG", image: QURNG_P },
  ];

  return (
    <div className="w-full flex flex-col items-center justify-center">
      {/* HEADER */}
      <div className="w-full flex flex-col items-center justify-center py-20 bg-primary7 text-white relative">
        {/* Background Glow (FIXED) */}
        <div
          className="absolute left-1/2 top-[60%] -translate-x-1/2 -translate-y-1/2 md:w-[80%] md:h-[12rem] z-0 pointer-events-none"
          style={{
            background:
              "radial-gradient(circle at center, rgba(70,196,255,0.2), transparent)",
            filter: "blur(70px)",
          }}
        />

        {/* CONTENT (bring above) */}
        <div className="relative z-10 flex items-center justify-center gap-5 md:gap-10 lg:gap-20">
          {/* Logo */}
          <div>
            <img
              src={QFORTE}
              alt="QForte"
              className="w-40 lg:w-60 object-contain"
            />
          </div>

          {/* Icons */}
          <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16 mb-10">
            {[CHECQ, QSLEEVE, QURNG].map((img, i) => (
              <div key={i} className="flex flex-col items-center gap-3">
                <div className="w-24 h-24 lg:w-32 lg:h-32 rounded-lg flex items-center justify-center shadow-[0_0_30px_rgba(34,211,238,0.3)]">
                  <img src={img} className="w-16 lg:w-20" />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* TABS */}
        <div className="relative z-10 w-full max-w-5xl flex bg-[#1B99D4]/20 mt-10 sm:gap-10 px-5">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`p-2 text-sm md:text-base font-medium transition cursor-pointer ${
                activeTab === tab.id
                  ? "text-white border-b-2 border-[#1B99D4]"
                  : "text-gray-400"
              }`}
            >
              <div className="flex items-center gap-3">
                <img src={tab.image} alt={tab.label} className="w-6 md:w-8" />
                {tab.label}
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* CONTENT */}
      <div className="w-full">
        {tabComponents[activeTab] || tabComponents["QSleeve"]}
      </div>
    </div>
  );
};

const ChecQ = () => {
  const requestDemoRef = useRef(null);
  const architectureRef = useRef(null);

  const scrollToRequestDemo = () => {
    requestDemoRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToArchitecture = () => {
    architectureRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const keyFeatures = [
    "AI-powered Comprehensive Analysis: Detailed security analysis for websites and source code in both pre-quantum and post-quantum eras.",
    "Detailed Cryptographic Bill of Materials (CBOM): Generate an exportable CBOM that inventories algorithms, keys, certificates, libraries, and protocols, providing complete visibility to assess, manage, and strengthen cryptographic resilience.",
    "Individual Severity Assessment: Highlights insecurity levels, aiding in prioritizing remediation efforts.",
    "User-Friendly Analysis Report: Generates detailed, easy-to-understand reports with post-quantum threat mitigation suggestions.",
  ];
  const specifications = [
    ["User Interface", "Software Application"],
    [
      "System requirements",
      "OS requirements: Windows 10 or higher macOS 10.13 or higher Linux (latest stable distributions)",
    ],
    ["Languages supported", "Python, C/C++, Java, Javascript"],
    [
      "Network Scanning",
      "Network Traffic Analysis: Captures and inspects data packets to identify active communication protocols Protocol Assessment: Evaluates the security of protocol within the captured traffic Cryptographic Vulnerability Detection: Identifies vulnerabl cryptographic algorithms, addressing both classical an quantum-related threats.",
    ],
    [
      "Certificate Scanning",
      "Comprehensive system-wide scans of all X.509 certificates to identify quantum-vulnerable, expired, and misconfigured cryptographic assets.",
    ],
  ];

  return (
    <>
      <div className="w-full h-[20rem] ">
        <ProductsHeroSection
          title1="ChecQ-AI: A Quantum"
          title2="Vulnerability Analysis Tool"
          content="Protect your systems from emerging quantum
computing threats with a comprehensive analysis."
          scrollToArchitecture={scrollToArchitecture}
        />
      </div>
      <div className="w-full h-[60vh]  width  flex-col items-center justify-center  hidden">
        <Scroll />
      </div>
      <div className="w-full bg-primary7 width md:px-10  flex flex-col items-center justify-center pb-10 gap-1">
        <div className="w-[90%] text-center md:text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold text-white leading-tight px-3 ">
          <span className="wordGradient">
            ChecQ-AI - Comprehensive Cryptographic Inventory and Risk Management
          </span>
        </div>

        <div className="w-[90%] h-full  grid grid-cols-1 xl:grid-cols-2  place-items-start p-3">
          <div className="w-full  flex flex-col items-center justify-center  gap-1">
            <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
              ChecQ-AI offers automated discovery and analysis of cryptographic
              assets across code, certificates, and networks, generating a
              detailed Cryptographic Bill of Materials (CBOM) and complete
              cryptographic inventory. This structured visibility accelerates
              quantum-safe migration and promotes crypto-agility. Leveraging
              AI-driven analytics, it pinpoints deprecated algorithms, weak key
              practices, and configuration Gaws, delivering prioritized,
              user-friendly reports that guide effective mitigation and
              strengthen enterprise cryptographic resilience.
            </div>
            <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
              Quantum computing leverages superposition and entanglement to
              perform computations far beyond classical capabilities. Algorithms
              such as Shor’s threaten the mathematical foundations of RSA and
              ECC, endangering nearly 70% of global cryptographic systems.
              ChecQ-AI enables organizations to stay ahead of this curve by
              detecting, classifying, and mitigating cryptographic weaknesses
              through AI-powered analysis and comprehensive cryptographic
              inventory management—forming the cornerstone of a quantum-safe and
              crypto-agile transformation strategy.
            </div>
          </div>

          <div className="w-full  flex flex-col items-start justify-start">
            <KeyFeatures
              title="Highlights"
              features={keyFeatures.slice(0, 4)}
            />
          </div>
        </div>

        <div className="w-[90%] h-full grid grid-cols-1 xl:grid-cols-2 gap-10 p-3">
          <div className="flex flex-col items-center justify-center">
            <ProductTable title="Specifications" data={specifications} />
          </div>
          <div className="flex flex-col  items-center justify-center">
            <img
              className="w-[21.5rem]  lg:w-[55.5rem] md:w-[600px]  object-contain rounded-lg md:rounded-2xl lg:mt-10"
              src={ChecQ_P1}
            ></img>
            <p className="w-full lg:max-w-[600px] text-center text-xs italic text-white/70 lg:pt-2">
              Figure 1: ChecQ AI Dashboard
            </p>
          </div>
        </div>
      </div>
      {/* <div className="w-full  width flex flex-col items-center justify-center  ">
        <img
          className="w-[21.5rem] h-[15.1rem] md:w-[55.5rem] md:h-[42.5rem] object-contain rounded-lg md:rounded-2xl"
          src={require("../../../src/Images/QSleeve Dashboard.png")}
        ></img>
      </div> */}
      {/* <div className="w-full width px-5 md:px-10 pt-14 md:pt-28 flex flex-col items-center justify-center  gap-1">
         <img
           className="md:w-[64rem] md:h-[30rem] object-contain "
           src={require("../../../src/Images/QSleeveDesign.png")}
         ></img>
         <p className="w-full text-center text-xs italic text-white/70 pt-2">
           Figure 1: QSleeve Dashboard
         </p>
       </div>
       <div
         className="w-full width px-5 md:px-10 pt-14 md:pt-24 flex flex-col items-center justify-center  gap-16"
         ref={architectureRef}
       >
         <div className="font-RobotoBold  wordGradient text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem]">
           ARCHITECTURE
         </div>
         <img
           className="md:w-[64rem] md:h-[30rem] object-contain"
           src={require("../../../src/Images/QSleeveArchitecture.png")}
         ></img>
         <p className="w-full text-center text-xs italic text-white/70 pt-2">
           Figure 1: QSleeve Dashboard
         </p>
       </div> */}
      <div className="w-full bg-primary7 width md:px-10 pt-28 flex flex-col items-center justify-center  gap-1">
        <div className="font-RobotoBold  wordGradient text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem]">
          KEY FEATURES
        </div>
        <div className="max-w-5xl  mx-auto px-3 md:px-8">
          <FeatureHover items={keyfeatures.Checq} />
        </div>
      </div>

      {currentSite === "site2" && (
        <VideoComponent
          video={"https://thequantum.ai/videos/ChecQVideo.mp4"}
        />)}
      {currentSite === "site1" && (
        <VideoComponent
          video={"https://qulabs.ai/videos/ChecQVideo.mp4"}
        />
      )}
      {/* <div
        className="w-full bg-primary7 width flex flex-col items-center justify-center gap-2 "
        ref={requestDemoRef}
      >
        <RequestDemo />
      </div> */}
    </>
  );
};

const QuRNG = () => {
  const requestDemoRef = useRef(null);
  const architectureRef = useRef(null);

  const scrollToRequestDemo = () => {
    requestDemoRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToArchitecture = () => {
    architectureRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const keyFeatures = [
    "Transparent design",
    "Secured",
    "Flexible and easy-to-use Confidential",
    "Test suites qualified",
    "Quantum hardware agnostic",
    "Accessible with any smart device",
    "Adaptable to applications",
    "Scalable architecture",
  ];
  const specifications = [
    ["Feature", "QuRNG"],
    ["Bit rate", ">15 Mbit/s"],
    ["NIST and Diehard Test Compliance", "Yes"],
    ["Quantum Tests", "CHSH Bell Test Qualified"],
    ["Scalability", "Easily scalable with software updates"],
    ["External Dependencies", "None"],
    ["Requirement", "Internet connectivity"],
    ["Compatible Quantum Computers", "IBMQ, Rigetti, etc."],
    ["Channel Security", "Post-Quantum Cryptography Enabled"],
    ["Security Vault", "Hosted in-house with Post-Quantum Encryption"],
    [
      "Post Quantum Encryption",
      "Quantum wrapper channel for secure key transmission",
    ],
    ["SaaS", "Yes"],
  ];

  return (
    <>
      <div className="w-full h-[20rem] ">
        <ProductsHeroSection
          title1="Quantum"
          title2="Random Number Generator"
          content="A Hardware Agnostic Quantum
Random Number Generator"
          scrollToArchitecture={scrollToArchitecture}
        />
      </div>
      <div className="w-full h-[60vh]  width  flex-col items-center justify-center  hidden">
        <Scroll />
      </div>
      <div className="w-full bg-primary7 width md:px-10  flex flex-col items-center justify-center pb-10 gap-1">
        <div className="w-[90%] text-center md:text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold text-white leading-tight px-3 ">
          <span className="wordGradient">QuRNG</span>
        </div>

        <div className="w-[90%] h-full  grid grid-cols-1 xl:grid-cols-2  place-items-start p-3">
          <div className="w-full  flex flex-col items-center justify-center  gap-1">
            <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
              QuRNG is a revolutionary product developed by QAIG that overcomes
              accessibility barriers and guarantees high-quality random bits
              anytime and anywhere from various quantum hardware sources. Its
              unique design eliminates reliance on dedicated quantum hardware,
              simplifying software integration. Users can select their entropy
              source and run multiple QRNGs in parallel. QuRNG™ is a hybrid
              Quantum-Classical software utilizing a quantum subroutine
              compatible with any gate-based quantum computer to generate random
              numbers. It combines the high-quality randomness of hardware QRNGs
              with the scalability and ease of integration found in
              software-based Pseudorandom Number Generators (PRNGs), ensuring
              robust, scalable, and easily integrable random number generation.
            </div>
            <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
              Random numbers form the bedrock of security and privacy in our
              digitally dependent era. The quest for true randomness has driven
              numerous advancements in Random Number Generator (RNG) technology.
              Quantum Random Number Generators (QRNGs) harness the inherent
              randomness of quantum mechanics. For instance, a single photon
              passing through a beam splitter exhibits unpredictable behavior
              according to quantum laws, resulting in truly random outcomes.
              QRNGs offer unparalleled promise for ensuring quantum-secure
              communications and data protection. However, current QRNGs are
              hardware-based, requiring dedicated quantum hardware, and users
              must trust vendors for the quality of random bits generated.
            </div>
            <div className="w-full  flex flex-col items-start justify-start">
              <KeyFeatures features={keyFeatures.slice(0, 8)} />
            </div>
          </div>

          <div className="w-full  flex flex-col items-start justify-start">
            <ProductTable title="Specifications" data={specifications} />
          </div>
        </div>

        <div
          className="w-full bg-primary7 width px-5 md:px-10 pt-14 md:pt-24 flex flex-col items-center justify-center  gap-16"
          ref={architectureRef}
        >
          <div className="font-RobotoBold  wordGradient text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem]">
            ARCHITECTURE
          </div>
          <img
            className="w-[21.5rem]   md:w-[600px]  object-contain rounded-lg md:rounded-2xl"
            src={QuRNG_P1}
          ></img>
          <p className="w-full lg:max-w-[600px] text-center text-xs italic text-white/70 ">
            Figure 1: QuRNG Architecture
          </p>
        </div>
       

        {/* <div className="w-[90%] h-full grid grid-cols-1 md:grid-cols-2  p-3">
           <div className="flex flex-col items-center justify-center">
             <ProductTable title="Specifications" data={specifications} />
           </div>
           <div className="flex flex-col items-center justify-center">
             <img
               className="w-[21.5rem] h-[15.1rem]  object-contain rounded-lg md:rounded-2xl"
               src={require("../../../src/Images/QSleeve Dashboard.png")}
             ></img>
             <p className="w-full text-center text-xs italic text-white/70 pt-2">
               Figure 1: ChecQ AI Dashboard
             </p>
           </div>
         </div> */}
      </div>
      {/* <div className="w-full  width flex flex-col items-center justify-center  ">
        <img
          className="w-[21.5rem] h-[15.1rem] md:w-[55.5rem] md:h-[42.5rem] object-contain rounded-lg md:rounded-2xl"
          src={require("../../../src/Images/QSleeve Dashboard.png")}
        ></img>
      </div> */}
      {/* <div className="w-full width px-5 md:px-10 pt-14 md:pt-28 flex flex-col items-center justify-center  gap-1">
         <img
           className="md:w-[64rem] md:h-[30rem] object-contain "
           src={require("../../../src/Images/QSleeveDesign.png")}
         ></img>
         <p className="w-full text-center text-xs italic text-white/70 pt-2">
           Figure 1: QSleeve Dashboard
         </p>
       </div>
       <div
         className="w-full width px-5 md:px-10 pt-14 md:pt-24 flex flex-col items-center justify-center  gap-16"
         ref={architectureRef}
       >
         <div className="font-RobotoBold  wordGradient text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem]">
           ARCHITECTURE
         </div>
         <img
           className="md:w-[64rem] md:h-[30rem] object-contain"
           src={require("../../../src/Images/QSleeveArchitecture.png")}
         ></img>
         <p className="w-full text-center text-xs italic text-white/70 pt-2">
           Figure 1: QSleeve Dashboard
         </p>
       </div> */}
      {/* <div className="w-full width md:px-10 pt-28 flex flex-col items-center justify-center  gap-1">
         <div className="font-RobotoBold  wordGradient text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem]">
           KEY FEATURES
         </div>
         <div className="max-w-5xl  mx-auto px-3 md:px-8">
           <FeatureHover items={keyfeatures.Checq} />
         </div>
       </div> */}

      <VideoComponent
        image={QSleeveImage}
        video={"https://thequantum.ai/videos/QSleeveVideo.mp4"}
      />
      {/* <div
        className="w-full bg-primary7 width flex flex-col items-center justify-center gap-2 "
        ref={requestDemoRef}
      >
        <RequestDemo />
      </div> */}
    </>
  );
};

const QSleeve = () => {
  const requestDemoRef = useRef(null);
  const architectureRef = useRef(null);

  const scrollToRequestDemo = () => {
    requestDemoRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToArchitecture = () => {
    architectureRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const keyFeatures = [
    "Quantum-Safe Protection: QSleeve ensures secure data transmission and protection against future quantum decryption threats as organizations transition to post-quantum cryptography (PQC).",
    "NIST-Standardized Algorithms: Integrating NIST-approved algorithms like ML-KEM and ML-DSA, QSleeve provides quantum-resilience for enterprise systems and communications.",
    "Seamless Integration Across Platforms: Easily deployable in on-premises, cloud, and hybrid environments, QSleeve integrates quantum-safe protocols without disrupting existing infrastructure.",
    "Comprehensive Security Across Use Cases:QSleeve offers quantum-safe encryption forremote access, site-to-site connectivity,cloud security, IoT protection, andsensitive transactions.",
  ];
  const specifications = [
    ["Specification", "Description"],
    ["Computing Infrastructure", "CPU & GPU (T4, V100, A100, H100 supported)"],
    ["Simulation Types", "Statevector, Noisy Density Matrix"],
    [
      "Supported Algorithms",
      "Complete spectrum: Grover’s, QFT, VQE, QAOA, QNNs, Quantum Chemistry and more",
    ],
    ["Noise Models", "Gate errors, decoherence, readout noise"],
    ["Qubits Simulatable", "Up to 32 (noiseless), up to 9 (with noise)"],
    [
      "GUI Capabilities",
      "Drag-and-drop circuit builder and Educational Mode for Quantum Learning",
    ],
    [
      "Educational Mode",
      "Quantum algorithms tutorials, circuit design tasks, guided modules for approximation of QPU behavior",
    ],
    [
      "Output",
      "Probability graph distribution, Basis state probability distribution, qubit representation on Bloch Sphere, analysis of Bloch sphere, and intuitive interpretation of quantum algorithms",
    ],
    [
      "Multi-user Environment",
      "Classroom/Lab deployment ready, JupyterHub compatible",
    ],
  ];

  return (
    <>
      <div className="w-full h-[20rem] ">
        <ProductsHeroSection
          title1="A Quantum-safe"
          title2="solution for PQC migration"
          content="Secure your organization from classical and quantum risks with our advanced VPN solutions"
          scrollToArchitecture={scrollToArchitecture}
        />
      </div>
      <div className="w-full h-[60vh]  width  flex-col items-center justify-center  hidden">
        <Scroll />
      </div>
      <div className="w-full bg-primary7 width md:px-10  flex flex-col items-center justify-center pb-10 gap-1">
        <div className="w-[90%] text-center md:text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold text-white leading-tight px-3 ">
          <span className="wordGradient">QSleeve-Quantum safe VPN</span>
        </div>

        <div className="w-[90%] h-full  grid grid-cols-1 xl:grid-cols-2  place-items-start p-3">
          <div className="w-full  flex flex-col items-center justify-center  gap-1">
            <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
              As part of a strategic migration to PQC, QSleeve allows
              organizations to integrate quantum-safe protocols seamlessly into
              their existing infrastructure. This solution is designed to be
              highly adaptable, enabling smooth implementation across
              on-premises, cloud, and hybrid IT environments. With its
              user-friendly interface, QSleeve simplifies the management and
              deployment of quantum-safe communication, making it accessible to
              both technical and non-technical users. By providing secure,
              quantum-resistant access across all platforms, it ensures that
              organizational data remains protected against future quantum
              threats, all while supporting the evolution of digital
              infrastructures.­­­­­­
            </div>
            <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
              The rapid advancement of quantum computing highlights the need to
              transition to quantum-secure Public Key Infrastructure (PKI). To
              address these emerging risks, the National Institute of Standards
              and Technology (NIST) has developed post-quantum cryptographic
              (PQC) standards, including FIPS 203: Module-Lattice-Based Key
              Encapsulation Mechanism (ML-KEM) and FIPS 204:
              Module-Lattice-Based Digital Signature Algorithm (ML-DSA) for key
              encapsulation and digital signatures, and FIPS 205: Stateless
              Hash-Based Digital Signature Standard. QSleeve offers quantum-safe
              protection by integrating these NIST-standardized algorithms,
              ensuring secure data transmission and safeguarding sensitive
              information against future quantum decryption threats. This makes
              it a vital solution for organizations preparing for a
              quantum-secure future.
            </div>
          </div>

          <div className="w-full  flex flex-col items-start justify-start">
            <KeyFeatures
              title="Highlights"
              features={keyFeatures.slice(0, 4)}
            />
          </div>
        </div>
        <div className=" relative w-full bg-primary7 width  pt-10 my-10 flex flex-col items-center justify-center  gap-1 ">
          <div className="font-RobotoBold  wordGradient text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem]">
            SERVICES
          </div>
          <div className="w-full h-auto md:h-[30rem] my-10 width gap-10 md:gap-0  flex lg:flex-row flex-col justify-center items-center md:px-10 ">
            <div className="h-full w-[90%] lg:w-[30%] flex flex-col justify-center items-center   py-3 md:pl-20 ">
              <div className="w-full  flex flex-col items-center justify-center gap-1">
                <div className="w-full  text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold text-white leading-tight px-3">
                  The Easiest Way To
                </div>{" "}
                <div className="w-full  text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold wordGradient leading-tight px-3">
                  Secure Your Data
                </div>
              </div>
              <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
                QSleeve ensures your data stays secure, even against the quantum
                threats. Built with advanced post-quantum cryptography, it
                offers unparalleled protection, future-proofing your privacy and
                safeguarding sensitive communications.
              </div>
            </div>
            <div className="h-full flex items-center justify-center w-[90%] lg:w-[50%]">
              <Corousel Data={servicestackdata.QSleeve} />
              {/* <CardStack items={servicestackdata} /> */}
            </div>
            <div
              className="absolute -z-2 left-1/2 top-[60%] transform -translate-x-1/2 -translate-y-1/2 inset-0 md:w-[80%] md:h-[12rem]"
              style={{
                background:
                  "radial-gradient(circle at center, rgba(70,196,255,0.2), transparent )",
                filter: "blur(70px)",
              }}
            ></div>
          </div>
        </div>
        <div className="w-[90%] h-full flex flex-col md:flex-row justify-center items-center   p-3">
          <div className="w-full flex flex-col items-center justify-center">
            <img
              className="md:w-[64rem]  object-contain "
              src={require("../../../src/Images/QSleeveDesign.png")}
            ></img>

            {/* <p className="w-full text-center text-xs italic text-white/70 lg:pt-2">
              Figure 1: QSleeve Dashboard
            </p> */}
          </div>
        </div>
      </div>
      {/* <div className="w-full  width flex flex-col items-center justify-center  ">
        <img
          className="w-[21.5rem] h-[15.1rem] md:w-[55.5rem] md:h-[42.5rem] object-contain rounded-lg md:rounded-2xl"
          src={require("../../../src/Images/QSleeve Dashboard.png")}
        ></img>
        </div> */}
      <div
        className="w-full bg-primary7 width px-5 md:px-10 pt-14 md:pt-24 flex flex-col items-center justify-center  gap-16"
        ref={architectureRef}
      >
        <div className="font-RobotoBold  wordGradient text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem]">
          ARCHITECTURE
        </div>
        <img
          className="md:w-[64rem]  object-contain"
          src={require("../../../src/Images/QSleeveArchitecture.png")}
        ></img>
        <p className="w-full lg:max-w-[600px] text-center text-xs italic text-white/70 lg:pt-2">
          Figure 1: QSleeve Architecture
        </p>
      </div>
      <div className="w-full bg-primary7 width px-5 md:px-10 pt-14 md:pt-28 flex flex-col items-center justify-center  gap-1">
        <img
          className="w-[21.5rem]  lg:w-[55.5rem] md:w-[600px]  object-contain rounded-lg md:rounded-2xl"
          src={QSLEEVE_P1}
        ></img>
        <p className="w-full lg:max-w-[600px] text-center text-xs italic text-white/70 lg:pt-2">
          Figure 2: QSleeve Dashboard
        </p>
      </div>
      <div className="w-full bg-primary7 width md:px-10 pt-28 flex flex-col items-center justify-center  gap-1">
        <div className="font-RobotoBold  wordGradient text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem]">
          KEY FEATURES
        </div>
        <div className="max-w-5xl  mx-auto px-3 md:px-8">
          <FeatureHover items={keyfeatures.QSleeve} />
        </div>
      </div>

      <VideoComponent
        image={QSleeveImage}
        video={"https://thequantum.ai/videos/QSleeveVideo.mp4"}
      />
      {/* <div
        className="w-full bg-primary7 width flex flex-col items-center justify-center gap-2 "
        ref={requestDemoRef}
      >
        <RequestDemo />
      </div> */}
    </>
  );
};

export default function QForte() {
  const requestDemoRef = useRef(null);
  const architectureRef = useRef(null);

  const [backgroundImage, setBackgroundImage] = useState(``);

  useEffect(() => {
    const updateBackgroundImage = () => {
      if (window.innerWidth < 640) {
        setBackgroundImage(`url(${BackgroundGradientSmall})`);
      } else {
        setBackgroundImage(`url(${BackgroundGradient})`);
      }
    };

    updateBackgroundImage();

    window.addEventListener("resize", updateBackgroundImage);

    return () => window.removeEventListener("resize", updateBackgroundImage);
  }, []);

  const scrollToRequestDemo = () => {
    requestDemoRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToArchitecture = () => {
    architectureRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="w-full  flex flex-col gap-0 items-center justify-center bg-primary7">
      <div
        className="w-full width flex flex-col gap-0 items-center justify-center bg-contain bg-repeat"
        style={{ backgroundImage: backgroundImage }}
      >
        <ProductHeader scrollToRequestDemo={scrollToRequestDemo} />

        <TabsSection />

        <div
          className="w-full bg-primary7 width flex flex-col items-center justify-center gap-2 "
          ref={requestDemoRef}
        >
          <RequestDemo />
        </div>

        {/* <div className="w-full h-[33rem]">
            <IframeWithPoster
                src="https://www.youtube.com/embed/ldmpb0k5v7E?si=USYWzTZkxH2JxKxk"
                poster={QSleeveImage}
                allow="accelerometer; autoplay; controls; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
            />
        </div> */}
        <ProductFooter />
      </div>
    </div>
  );
}
